import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import StyledEngineProvider from '@material-ui/core/StyledEngineProvider';
import App from './App';
import { AuthProvider } from './contexts/CustomContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { FiltersProvider } from './contexts/FiltersContext';
import { AppInsightsProvider } from './contexts/ApplicationInsightsContext';

ReactDOM.render(
  <StrictMode>
    <HelmetProvider>
      <StyledEngineProvider injectFirst>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <FiltersProvider>
            <SettingsProvider>
              <BrowserRouter>
                <AuthProvider>
                  <AppInsightsProvider>
                    <App />
                  </AppInsightsProvider>
                </AuthProvider>
              </BrowserRouter>
            </SettingsProvider>
          </FiltersProvider>
        </LocalizationProvider>
      </StyledEngineProvider>
    </HelmetProvider>
  </StrictMode>, document.getElementById('root')
);
